// extracted by mini-css-extract-plugin
module.exports = {"sheetHeader":"TSSheet_sheetHeader__zgULB","sheetContent":"TSSheet_sheetContent__ZdZDf","wideContainer":"TSSheet_wideContainer__b6RZc"};